import {
  assetParameters,
  DEVICE_REQUIREMENTS
} from "seneca-common/features/calculation/module/consts";
import {
  ContentSource,
  ImageAssetParameters
} from "seneca-common/features/calculation/module/types";
import { MODULE_TYPE } from "seneca-common/features/module/module-types/simple-calculation";
import {
  mapToNewContentSource,
  OldContentSource
} from "seneca-common/features/module/module-types/simple-calculation/mapToNewContentSource";
import { ModuleRegistry } from "seneca-common/features/module/registry";
import { transformCdnImageUrl } from "seneca-common/utils/images";

export const registerComponentStaticInformation = (
  moduleRegistry: ModuleRegistry
) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.componentStaticInformation()
    .deviceRequirements(DEVICE_REQUIREMENTS)
    .assetParameters(assetParameters)
    // And also transform OldContentSource to ContentSource (for backwards compatibility)
    .transformModuleAssets(transformModuleAssets)
    .root.register();

function isOldContentSource(
  contentSource: any
): contentSource is OldContentSource {
  return !!contentSource.generationTemplate;
}

function transformModuleAssets(
  source: OldContentSource | ContentSource,
  assetParams: ImageAssetParameters
): ContentSource {
  const newSource = isOldContentSource(source)
    ? mapToNewContentSource(source)
    : source;

  if (newSource.imageUrl) {
    return {
      ...newSource,
      imageUrl: transformCdnImageUrl(newSource.imageUrl, assetParams.default)
    };
  }
  return newSource;
}
